import { get as _get, isString as _isString, find as _find } from "lodash";

import TranslationGerman from "./TranslationGerman";
import TranslationFrench from "./TranslationFrench";
import TranslationPortuguese from "./TranslationPortuguese";
import TranslationEnglish from "./TranslationEnglish";

// Supported languages
// Just add new entry here to support new language
const LANGUAGES = {
    GERMAN: {
        name: "de",
        file: TranslationGerman
    },
    FRENCH: {
        name: "fr",
        file: TranslationFrench
    },
    PORTUGUESE: {
        name: "pt",
        file: TranslationPortuguese
    },
    ENGLISH: {
        name: "en",
        file: TranslationEnglish
    }
};

class Translation {

    /**
     * Language accessor.
     * If the language is not set, we set it before returning the language.
     * We cannot use Translation.setLanguage in ExternalDependenciesConfiguration (some webpack modules are loaded before this is called),
     * so this is a quick and dirty fix.
     *
     * @return Object { name: "de", file: {...} }
     */
    get language() {
        if(!this._language) {
            this.setLanguage();
        }
        return this._language;
    }

    /**
     * Get the translation message from a given key.
     * @param {String} key      : translation key
     * @param {Object} params   : additional translation parameters. If provided, they will be replaced inside translation.
     *
     * Ex :
     *  my.key = 'Hello {gender}'
     *  translate('my.key', { gender: 'Mr' })
     *  Result : 'Hello Mr'
     */
    translate = (key, params = {}) => {
        var translation = _get(this.getLanguageFile().messages, key);

        if (translation) {
            if (_isString(translation)) {
                // Replace each param in translation message
                Object.keys(params).forEach((paramName) => {
                    translation = translation.replace(new RegExp(`\\{${paramName}\\}`, "g"), params[paramName]);
                });
                // Clean eventual remaining {} messages
                translation = translation.replace(new RegExp("\\{.*\\}", "g"), "");
            }
        } else {
            console.warn("Translation key '" + key + "' doesn't exists in translations");
        }

        return translation;
    };

    setLanguage = (language) => {
        let languageId;
        if(language) {
            languageId = language;
        } else if(typeof $ !== 'undefined') {
            languageId = $("html").attr("lang") || this.getLanguageName();
        } else {
            languageId = this.getLanguageName();
        }

        this._language = _find(LANGUAGES, (l) => l.name === languageId) || this.getDefaultLanguage();
    };

    get = (key) => _get(this.getLanguageFile().messages, key);

    getDefaultLanguage = () => LANGUAGES.GERMAN;
    getLanguageName = () => this.language.name;
    getLanguageFile = () => this.language.file;
}

export default new Translation();



// WEBPACK FOOTER //
// ./js/i18n/Translation.js